module.exports = __webpack_public_path__ + "static/media/cloud.ca6ee631.svg";